/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import _ from 'underscore';

// Date recurrence series generation

namespace('Slzr.Util', function(exports, top) {
  const $ = Slzr.jQuery;
  const {
    moment
  } = Slzr;

  // Returns true if the week difference between dates is in the sequence
  class WeekInterval {
    constructor(start_date, interval) {
      this.start_date = moment(start_date).set({day: 0});
      this.interval = interval;
    }

    matches(check_date) {
      const date = moment(check_date).set({day: 0});
      return (Math.ceil(date.diff(this.start_date, 'week', true)) % this.interval) === 0;
    }
  }

  // Returns true if the month difference between dates is in the sequence
  class MonthInterval {
    constructor(start_date, interval) {
      this.start_date = moment(start_date).set({date: 1});
      this.interval = interval;
    }

    matches(check_date) {
      const date = moment(check_date).set({date: 1});
      return (Math.ceil(date.diff(this.start_date, 'month', true)) % this.interval) === 0;
    }
  }

  class LastDayOfMonth {
    matches(check_date) {
      const date = moment(check_date);
      return date.date() === date.daysInMonth();
    }
  }

  exports.intervals = {WeekInterval, MonthInterval};

  // Returns a list of dates in the specified range, conforming to the specified recurrence options.
  return (function() {
    const Cls = (exports.DateRecurrence = class DateRecurrence {
      static initClass() {
        // First date in range
        this.prototype.start_date = null;
        // Last date in range (inclusive)
        this.prototype.end_date = null;
        // Array of days of week to include [0-6]
        this.prototype.weekdays = null;
        // Recurrence type
        //  none
        //  daily (on all days through end_date, +weekdays+ option ignored)
        //  weekly (on specified +weekdays+ through end_date); note that weekly with weekdays 0-6 is same as daily, but
        //                                                     can skip weeks with interval
        //  monthly (on specified date through end_date, +weekdays+ option ignored), will be "last day of month" if
        //                                                                           start date is the last date
        //  monthly_day (on specified day of week through end_date based on start_date, +weekdays+ option ignored)
        //  yearly (on specified date through end_date, +weekdays+ option ignored)
        this.prototype.type = null;
        // Limit to this number of dates
        this.prototype.limit = null;
        // Interval between recurrences
        this.prototype.interval = 1;
      }

      // Expected options:
      // start_date: the date of the first instance
      // end_date: the end of the recurrance range
      // weekdays: array of weekdays for recurrence to fall on (0=sunday, 1=monday, etc.)
      // type: recurrence type (none, daily, weekly, monthly)
      //
      // String formatted dates should be YYYY-MM-DD
      constructor(options) {
        // Parse start date into a moment object
        this.start_date = typeof(options.start_date) === 'string' ?
          moment(options.start_date, ['YYYY-MM-DD', 'MM/DD/YYYY', 'MM/DD/YY'])
        :
          moment(options.start_date);

        this.end_date = (options.end_date != null) ?
          typeof(options.end_date) === 'string' ?
            moment(options.end_date, ['YYYY-MM-DD', 'MM/DD/YYYY', 'MM/DD/YY'])
          :
            moment(options.end_date)
        :
          this.start_date;

        this.limit = (options.limit != null) ? options.limit : 1000;
        this.weekdays = (options.weekdays != null) ? options.weekdays : [0, 1, 2, 3, 4, 5, 6];
        this.type = (options.type != null) ? options.type : 'none';
        this.interval = (options.interval != null) ? options.interval : 1;
      }

      // Return dates in the range
      dates() {
        if ((this.type === 'none') || (this.type === 'once')) {
          // Single instance, just return start
          return [this.start_date.toDate()];
        } 
          // Primary recurrence rule
          const recurrence = moment(this.start_date).recur(this.end_date);
          let rules = [recurrence];

          // Set up recurrence rules
          switch (this.type) {
            case 'daily':
              recurrence
                .every(this.interval).day()
                .every(this.weekdays).dayOfWeek();
              break;
            case 'weekly':
              recurrence
                .every(this.weekdays).dayOfWeek();

              if (this.interval > 1) { rules.push(new WeekInterval(this.start_date, this.interval)); }
              break;
            case 'monthly':
              if (this.start_date.date() === this.start_date.daysInMonth()) {
                // Special exception: last date of months
                rules = [new LastDayOfMonth];
                if (this.interval > 1) { rules.push(new MonthInterval(this.start_date, this.interval)); }
              } else {
                recurrence
                  .every(this.interval).month();
              }
              break;
            case 'monthly_day':
              var week_of_month = this.start_date.monthWeekByDay();
              // If it's the 5th week, we want the last week (to move dates to 4th week)
              if (week_of_month === 4) { week_of_month = -1; }

              recurrence
                .every(this.start_date.day()).dayOfWeek()
                .every(week_of_month).weeksOfMonthByDay();

              // Additional recurrence rule
              if (this.interval > 1) { rules.push(new MonthInterval(this.start_date, this.interval)); }
              break;

            case 'yearly':
              recurrence
                .every(this.interval).year();
              break;
          }

          const date = this.start_date.clone();
          const result = [];

          // Loop over every possible date in the specified range, and include it
          // only if it falls on a specified weekday
          let i = 0; // Prevent infinite loops
          let added = 0;
          while ((added < this.limit) && (i < 10000) && moment(date).isSameOrBefore(this.end_date)) {
            i++;
            if (_.every(rules, rule => rule.matches(date))) {
              result.push(date.toDate());
              added += 1;
            }
            date.add({days: 1});
          }

          return result;
        
      }
    });
    Cls.initClass();
    return Cls;
  }());
});
